import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { RESET_CREATE_A_NEW_WORKFLOW } from 'ui-forms-editor-automation-lib/actions/resetCreateNewWorkflow';
import { FAIL_CREATING_A_NEW_WORKFLOW, REQUEST_CREATE_A_NEW_WORKFLOW, SUCCESS_CREATING_A_NEW_WORKFLOW } from 'ui-forms-editor-automation-lib/actions/createNewWorkflow';
import { FAIL_CREATING_FOLLOW_UP, REQUEST_CREATE_FOLLOW_UP, SUCCESS_CREATING_FOLLOW_UP } from 'ui-forms-editor-automation-lib/actions/createNewFollowUpEmail';
export const INITIAL_STATE = {
  requestStateFollowUp: NOT_REQUESTED,
  requestStateOwn: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_CREATE_A_NEW_WORKFLOW]: state => Object.assign({}, state, {
    requestStateOwn: REQUESTED
  }),
  [SUCCESS_CREATING_A_NEW_WORKFLOW]: state => Object.assign({}, state, {
    requestStateOwn: SUCCEEDED
  }),
  [FAIL_CREATING_A_NEW_WORKFLOW]: state => Object.assign({}, state, {
    requestStateOwn: FAILED
  }),
  [REQUEST_CREATE_FOLLOW_UP]: state => Object.assign({}, state, {
    requestStateFollowUp: REQUESTED
  }),
  [SUCCESS_CREATING_FOLLOW_UP]: state => Object.assign({}, state, {
    requestStateFollowUp: SUCCEEDED
  }),
  [FAIL_CREATING_FOLLOW_UP]: state => Object.assign({}, state, {
    requestStateFollowUp: FAILED
  }),
  [RESET_CREATE_A_NEW_WORKFLOW]: () => ({
    requestStateFollowUp: NOT_REQUESTED,
    requestStateOwn: NOT_REQUESTED
  })
}, INITIAL_STATE);